import nav from "./module/nav";
import totop from "./module/totop";

nav();
totop();



const header_h = $('.l-header').outerHeight();
function add_pt_header() {
	$('body').css({
		'paddingTop': header_h + 'px'
	});
}

$('a:not(".no-scroll")').click(function(){
	const href= $(this).attr("href");
	const target = $(href);
	const position = target.offset().top - header_h;
	$('body,html').stop().animate({scrollTop:position}, 500);
	return false;
});

$(window).on('load resize orientationchange',function() {
	add_pt_header();
});
